
import React, { useState, useEffect } from 'react';
import Plaintext from './plaintext';
import Text from './text';
import Helpers from 'utils/helpers';

export default function TextInputNumberFloatWrapper(props) {
  if (props.plaintext || props.readOnly || props.readonly || props.disabled) {
    return (
      <Plaintext style={props.style}>
        {Helpers.Object.exists(props.value) ? props.value : props.defaultValue}
      </Plaintext>
    );
  }
  else {
    return <TextInputNumberFloat {...props} />;
  }
}

function TextInputNumberFloat(props) {
  const { onChange, onValueChange, onBlur, deferChange, value, defaultValue, min, max, precision, ...childProps } = props;
  const minValue = parseFloat(min) || 0;
  const maxValue = parseFloat(max) || 2147483647;
  const precisionValue = parseInt(precision) || 20;

  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    setDisplayValue(value || defaultValue);
  }, [value, defaultValue]);

  const handleChange = (event) => {
    let index = 0
    const newValue = event.target.value.replace(/[^\d.]/g, '').replace(/\./g, (item) => (!index++ ? item : ''));
    if (newValue !== displayValue) {
      setDisplayValue(newValue);
      if (onChange) {
        const syntheticEvent = { ...event };
        syntheticEvent.target.value = newValue;
        onChange(syntheticEvent);
      }
      if (onValueChange && !deferChange) {
        onValueChange(newValue);
      }
    }
  };

  const handleBlur = (event) => {
    const value = (!displayValue || displayValue.length === 0) ? 0 : parseFloat(displayValue);
    let newValue = value;
    if (value < minValue) {
      newValue = minValue;
    }
    else if (value > maxValue) {
      newValue = maxValue;
    }
    newValue = parseFloat(newValue.toFixed(precisionValue));

    if (newValue !== value) {
      setDisplayValue(newValue);
      if (onChange) {
        const syntheticEvent = {
          target: {
            value: newValue,
          },
        };
        onChange(syntheticEvent);
      }
      if (onValueChange) {
        onValueChange(newValue);
      }
    }
    if (onValueChange && deferChange) {
      onValueChange(newValue);
    }
    if (onBlur) {
      onBlur(event);
    }
  };

  return (
    <Text
      {...childProps}
      value={displayValue || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      inputMode='numeric'
      pattern='[0-9.]*'
      validation='number'
    />
  );
}